import Actividad from "../models/Actividad";

import Imagen from "../models/Imagen";

export const getImagenesEntorno = () => {
    
    const imagenesEntorno: Imagen[] = [
        new Imagen("./img/sections/ent1.jpg","Imagen1"),
        new Imagen("./img/sections/ent2.jpg","Imagen2"),
        new Imagen("./img/sections/ent3.jpg","Imagen3"),
        new Imagen("./img/sections/ent4.jpg","Imagen4"),
        new Imagen("./img/sections/ent5.jpg","Imagen5"),
        new Imagen("./img/sections/ent6.jpg","Imagen6")
    ];

    return imagenesEntorno;

} 